import * as firebase from 'firebase'
import '@firebase/messaging'
import { notification } from 'antd'
import quiteImpressed from './../audios/quite-impressed.ogg'

// production
const firebaseConfig = {
    apiKey: 'AIzaSyA7phsTi-UYNbL1SMPauDd0IrMQMvel7Gk',
    authDomain: 'reservandoapp.firebaseapp.com',
    databaseURL: 'https://reservandoapp.firebaseio.com',
    projectId: 'reservandoapp',
    storageBucket: 'reservandoapp.appspot.com',
    messagingSenderId: '555709096118',
    appId: '1:555709096118:web:3f0bfb5bb532b326'
}

// development
// const firebaseConfig = {
//     apiKey: 'AIzaSyA1cmTwG6BJGh0YLvZtLU7UIhYSaVfGh48',
//     authDomain: 'reservando-dev.firebaseapp.com',
//     databaseURL: 'https://reservando-dev.firebaseio.com',
//     projectId: 'reservando-dev',
//     storageBucket: 'reservando-dev.appspot.com',
//     messagingSenderId: '898432296804',
//     appId: '1:898432296804:web:12256468e822af44'
// }

const fire = firebase.initializeApp(firebaseConfig)

const db = firebase.database()
const auth = firebase.auth()
const storage = firebase.storage()
let messaging
if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging()
    messaging.onMessage(function (payload) {
        openNotification(payload)
        playSound()
    })
}

function openNotification (payload) {
    const args = {
        message: payload.data.title,
        description: payload.data.body,
        duration: 0
    }
    notification.open(args)
}

function playSound () {
    let audio = new Audio(quiteImpressed)
    audio.play()
}

const cloudFunctions = {
    tryAcceptReservation: data => firebase.functions().httpsCallable('tryAcceptReservation')(data),
    tryAssistReservation: data => firebase.functions().httpsCallable('tryAssistReservation')(data),
    tryRejectReservation: data => firebase.functions().httpsCallable('tryRejectReservation')(data),
    createNewRestaurant: data => firebase.functions().httpsCallable('createNewRestaurant')(data),
    verifyEmail: data => firebase.functions().httpsCallable('verifyEmail')(data),
    generateDeepLinksRestos: data => firebase.functions().httpsCallable('generateDeepLinksRestos')(data),
    sendEmailVerification: data => firebase.functions().httpsCallable('sendEmailVerification')(data),
    sendPushToUsers: data => firebase.functions().httpsCallable('sendPushToUsers')(data),
    actualizeRestos: data => firebase.functions().httpsCallable('actualizeRestos')(data),
    actualizeReservations: data => firebase.functions().httpsCallable('actualizeReservations')(data),
    tryJoinReserve: data => firebase.functions().httpsCallable('tryJoinReserve')(data),
    tryJoinReserveByRestaurant: data => firebase.functions().httpsCallable('tryJoinReserveByRestaurant')(data),
    tryChangeAssistanceUserInReservation: data => firebase.functions().httpsCallable('tryChangeAssistanceUserInReservation')(data),
    notifyAssistedReservations: data => firebase.functions().httpsCallable('notifyAssistedReservations')(data),
    getAvailableHoursPerDate: data => firebase.functions().httpsCallable('getAvailableHoursPerDate')(data),
    tryReserveFromRestaurant: data => firebase.functions().httpsCallable('tryReserveFromRestaurant')(data)
}

const admin = {}

export { db, auth, storage, admin, fire, cloudFunctions, messaging }